import Styles from "./Library.module.scss";


interface LibraryProps{
    images:any;
    onClickImage:(id:string,index:number)=>void;
}


const Library = ({images,onClickImage}:LibraryProps) => {

  return (
    <div className={Styles.container}>
      {
        Object.keys(images).map((key:string,index:number)=>{
            return (
                <div className={Styles.image_container} onDoubleClick={()=>{onClickImage(key,index)}} key={key}>
                    <img className={Styles.image} src={images[key]} loading="lazy"/>
                    <div className={Styles.label}>
                        {`DISC_${Object.keys(images).length-index}.png`}
                    </div>
                </div>

            )
        })
      }
    </div>
  )
}

export default Library
